import { FC } from 'react';
import Svg, { SvgProps } from '@/components/shared/Svg/Svg.tsx';

const CheckIcon: FC<Omit<SvgProps, 'children'>> = (props) => {
  return (
    <Svg viewBox="0 0 32 29" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3521 0.24368C32.0205 0.687888 32.2012 1.58814 31.7556 2.25446L14.3011 28.3543C14.0594 28.7158 13.6678 28.9501 13.2342 28.9929C12.8005 29.0357 12.3705 28.8825 12.0623 28.5753L0.426024 16.9754C-0.142008 16.4091 -0.142008 15.491 0.426024 14.9248C0.994057 14.3585 1.91502 14.3585 2.48305 14.9248L12.8648 25.274L29.3351 0.645835C29.7807 -0.0204777 30.6837 -0.200529 31.3521 0.24368Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default CheckIcon;
